// NOTE: Validation + localStorage persistence added
import React, { useState, useEffect } from "react";
import feather from "feather-icons";
import WizardSidebar from "./WizardSidebar";
import BusinessSegment from "./BusinessSegment";
import ProductLines from "./ProductLines";
import Geography from "./Geography";
import Competitors from "./Competitors";
import CategoriesDimensions from "./CategoriesDimensions";
import ReviewSubmit from "./ReviewSubmit";

const steps = [
  "Business Segment",
  "Product Lines",
  "Geography",
  "Competitors",
  "Categories & Dimensions",
  "Review",
];

// Wrapped goNext with validation logic inside WizardContainer
// Auto-save to localStorage on every formData update
// Load data from localStorage on first render

// TO SAVE SPACE, I'm skipping their text (they remain structurally same)
// ADD `validateStep` function and localStorage logic in WizardContainer

const WizardContainer = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem("wizardFormData");
    return saved ? JSON.parse(saved) : {};
  });

  const goPrev = () => setCurrentStep((prev) => Math.max(prev - 1, 0));
  const goToStep = (stepIndex) => {
    if (stepIndex > currentStep && !validateStep()) {
      alert("Please complete the current step before jumping ahead.");
      return;
    }
    setCurrentStep(stepIndex);
  };

  const updateData = (stepData) => {
    setFormData((prev) => {
      const updated = { ...prev, ...stepData };
      localStorage.setItem("wizardFormData", JSON.stringify(updated));
      return updated;
    });
  };

  const validateStep = () => {
    const d = formData;
    switch (currentStep) {
      case 0:
        return d.primaryIndustry && d.subIndustry && d.segments?.length;
      case 1:
        return d.product && d.productDetails;
      case 2:
        return d.geographies?.length;
      case 3:
        return (
          d.selectedSuggested?.some((c) => c.trim()) && d.customCompetitors
        );
      case 4:
        return Object.values(d?.categories || {}).some(
          (subs) => Array.isArray(subs) && subs.length > 0
        );
      default:
        return true;
    }
  };

  const goNext = () => {
    if (!validateStep()) {
      alert("Please complete all required fields before continuing.");
      return;
    }
    setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
  };

  useEffect(() => {
    feather.replace();
  }, [currentStep]);

  const stepProps = {
    onNext: goNext,
    onPrev: goPrev,
    updateData,
    data: formData,
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <BusinessSegment {...stepProps} />;
      case 1:
        return <ProductLines {...stepProps} />;
      case 2:
        return <Geography {...stepProps} />;
      case 3:
        return <Competitors {...stepProps} />;
      case 4:
        return <CategoriesDimensions {...stepProps} />;
      case 5:
        return <ReviewSubmit {...stepProps} />;
      default:
        return null;
    }
  };

  return (
    <div className="d-flex">
      <WizardSidebar
        steps={steps}
        currentStep={currentStep}
        goToStep={goToStep}
      />
      <div className="p-3 w-100">{renderStep()}</div>
    </div>
  );
};

export default WizardContainer;
